'use strict';

app.factory('DashboardDataServiceDemo', function ($http, $state, $q) {
    return {
        dataProvider: dataProvider,
        getTileLayout: getTileLayout,
        getData: getData,
        goto: goto,
    }

    function dataProvider() {
        return 'Demo';
    }

    function goto(tile, item) {
        var params = {};
        switch (tile.title) {
            case 'Mise à jour':
                params.name = item.name;
                params.value = item.value;
                params.image = item.image;
                params.z = 28;
                $state.go('app.list.set', params);
                break;
            default:
                console.log("State not found for tile: " + tile.title);
                break;
        }

    }

    function getTileLayout() {
        var tiles = [
            {
                title: 'PAP',
                type: 'counter',
                template: '',
                width: 1, height: 1,
                dataSource: 'inline',
                value: '224',
                label: 'PAP',
                image: 'nb_elements_map.png'
            },
            {
                title: 'A la une',
                type: 'table',
                template: 'carrefour.big',
                width: 1, height: 2,
                dataSource: 'inline',
                dataUrl: '',
                
                value: [
                    { name: 'Hypermarchés', value: 132, image: 'carrefour-logo.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-express.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-bio.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-city.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-market.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-contact.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-bonapp.png' },
                    { name: 'Hypermarchés', value: 12, image: 'logo-carrefour-contact-marche.png' },
                ],
            },
            {
                title: 'Placeholder',
                type: 'placeholder',
                template: '',
                width: 1, height: 1,
                dataSource: 'inline',
                value: '100',
                label: 'Placeholder',
                image: 'maquette-carrefour.png'
            },
            {
                title: 'Mise à jour',
                type: 'table',
                template: '1',
                width: 1, height: 2,
                dataSource: 'database',
                
                value: [
                    { name: '24 mois', value: 12343, image: 'carrefour-logo.png' },
                    { name: '36 mois', value: 43543, image: 'logo-carrefour-express.png' },
                    { name: '48 mois', value: 423, image: 'logo-carrefour-bio.png' },
                    { name: '6 mois', value: 43242, image: 'logo-carrefour-city.png' },
                    { name: '12 mois', value: 97898, image: 'logo-carrefour-market.png' },
                ],
            },
            {
                title: 'Template',
                type: 'table',
                template: '2',
                width: 1, height: 2,
                dataSource: 'inline',
                
                value: [
                    { name: 'Template vidéo', value: 423, image: 'carrefour-logo.png' },
                    { name: 'Template hub', value: 43242, image: 'logo-carrefour-express.png' },
                    { name: 'Template image', value: 423, image: 'logo-carrefour-bio.png' },
                    { name: 'Template image 2', value: 97898, image: 'logo-carrefour-city.png' },
                ],
            },
            {
                title: 'Top des services',
                type: 'table',
                template: '3',
                width: 1, height: 2,
                dataSource: 'inline',
                
                value: [
                    { name: 'Vidéo', value: 423, image: 'carrefour-logo.png' },
                    { name: 'Hub', value: 43242, image: 'logo-carrefour-express.png' },
                    { name: 'Image', value: 423, image: 'logo-carrefour-bio.png' },
                    { name: 'Image 2', value: 97898, image: 'logo-carrefour-city.png' },
                ],
            },
            {
                title: 'Publications',
                type: 'text',
                template: '',
                width: 1, height: 2,
                dataSource: 'inline',
                value: ' <ul><li class="publication">Date de sortie du guide papier :<span>25/08/2017</span></li></ul><p class="list-city"><span><a>Paris</a></span> |<span><a>Tokyo</a></span> |<span><a>Amsterdam</a></span> |<span><a>Bangkok</a></span> |<span><a>Berlin</a></span> |<span><a>Chicago</a></span> |<span><a>Hong Kong</a></span> |<span><a>New York</a></span> |<span><a>Londres</a></span> |<span><a>Lisbonne</a></span></p>',
            },
            {
                title: 'News',
                type: 'slide',
                template: '',
                width: 1, height: 2,
                dataSource: 'inline',
                value: [
                    { name: 'Vidéo', value: 423, image: 'carrefour-logo.png', type:'Restaurant', city:'HK', sender:'HK sender' },
                    { name: 'Hub', value: 43242, image: 'logo-carrefour-express.png', type:'Restaurant 2', sender:'HK sender' },
                    { name: 'Image', value: 423, image: 'logo-carrefour-bio.png', type:'Restaurant 3', sender:'HK sender' },
                    { name: 'Image 2', value: 97898, image: 'logo-carrefour-city.png', type:'Restaurant 4', sender:'HK sender' },
                ],
            },
            {
                title: 'Chartdonut',
                type: 'donut',
                template: '',
                image: 'nb_elements_map.png', 
                width: 1, height: 2,
                dataSource: 'inline',
                value: [
                    { name: 'Vidéo', value: 5, image: 'carrefour-logo.png' },
                    { name: 'Hub', value: 10, image: 'logo-carrefour-express.png' },
                    { name: 'Image', value: 15, image: 'logo-carrefour-bio.png' },
                    { name: 'Image 2', value: 20, image: 'logo-carrefour-city.png' },
                ],
            },
        ];
        
        return $q.when(tiles);
        //return tiles;
    }

    function getData(tile) {
        return $q.when(tile.value);
    }

});
